function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import React, { Component } from 'react';
/**
 * Shared Error Boundary Component
 * 
 * FSD Architecture: shared/ui layer component
 * A reusable error boundary component that provides graceful error handling
 * with customizable UI and behavior options.
 * 
 * @example
 * ```tsx
 * // Basic usage
 * <ErrorBoundary>
 *   <YourApp />
 * </ErrorBoundary>
 * 
 * // With custom fallback
 * <ErrorBoundary
 *   fallback={<CustomErrorPage />}
 *   onError={(error) => logToService(error)}
 * >
 *   <YourApp />
 * </ErrorBoundary>
 * 
 * // With custom styling and messages
 * <ErrorBoundary
 *   errorTitle="Oops! Something went wrong"
 *   errorMessage="Please try refreshing the page"
 *   buttonLabels={{ home: "Go Home", reload: "Refresh" }}
 * >
 *   <YourApp />
 * </ErrorBoundary>
 * ```
 */ export var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorBoundary, Component);
    function ErrorBoundary() {
        _class_call_check(this, ErrorBoundary);
        var _this;
        _this = _call_super(this, ErrorBoundary, arguments), _define_property(_this, "state", {
            hasError: false,
            error: null,
            errorInfo: null
        }), _define_property(_this, "handleReset", function() {
            if (_this.props.onReset) {
                _this.props.onReset();
            } else {
                // Default reset behavior
                var homeUrl = _this.props.homeUrl || '/ko/feed';
                window.location.href = homeUrl;
            }
        }), _define_property(_this, "handleReload", function() {
            if (_this.props.onReload) {
                _this.props.onReload();
            } else {
                // Default reload behavior
                window.location.reload();
            }
        });
        return _this;
    }
    _create_class(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                // Log error to console
                console.error('ErrorBoundary caught an error:', error, errorInfo);
                // Update state with error details
                this.setState({
                    error: error,
                    errorInfo: errorInfo
                });
                // Call custom error handler if provided
                if (this.props.onError) {
                    this.props.onError(error, errorInfo);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) {
                    // Use custom fallback if provided
                    if (this.props.fallback) {
                        return this.props.fallback;
                    }
                    // Default error UI
                    var _this_props = this.props, _this_props_showDetails = _this_props.showDetails, showDetails = _this_props_showDetails === void 0 ? process.env.NODE_ENV === 'development' : _this_props_showDetails, _this_props_containerStyle = _this_props.containerStyle, containerStyle = _this_props_containerStyle === void 0 ? {} : _this_props_containerStyle, _this_props_errorTitle = _this_props.errorTitle, errorTitle = _this_props_errorTitle === void 0 ? '문제가 발생했습니다' : _this_props_errorTitle, _this_props_errorMessage = _this_props.errorMessage, errorMessage = _this_props_errorMessage === void 0 ? '예상치 못한 오류가 발생했습니다. 불편을 드려 죄송합니다.' : _this_props_errorMessage, _this_props_buttonLabels = _this_props.buttonLabels, buttonLabels = _this_props_buttonLabels === void 0 ? {} : _this_props_buttonLabels;
                    var _buttonLabels_home = buttonLabels.home, home = _buttonLabels_home === void 0 ? '홈으로 이동' : _buttonLabels_home, _buttonLabels_reload = buttonLabels.reload, reload = _buttonLabels_reload === void 0 ? '페이지 새로고침' : _buttonLabels_reload;
                    var defaultContainerStyle = _object_spread({
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '100vh',
                        padding: '20px',
                        fontFamily: 'system-ui, -apple-system, sans-serif',
                        backgroundColor: '#f5f5f5'
                    }, containerStyle);
                    var cardStyle = {
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '40px',
                        maxWidth: '600px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        textAlign: 'center'
                    };
                    var titleStyle = {
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: '#333',
                        marginBottom: '16px'
                    };
                    var messageStyle = {
                        fontSize: '16px',
                        color: '#666',
                        marginBottom: '24px',
                        lineHeight: '1.5'
                    };
                    var detailsStyle = {
                        textAlign: 'left',
                        marginBottom: '24px',
                        padding: '16px',
                        backgroundColor: '#f8f8f8',
                        borderRadius: '8px',
                        fontSize: '14px'
                    };
                    var buttonContainerStyle = {
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'center'
                    };
                    var primaryButtonStyle = {
                        padding: '12px 24px',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: 'white',
                        backgroundColor: '#3182ce',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s'
                    };
                    var secondaryButtonStyle = {
                        padding: '12px 24px',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#333',
                        backgroundColor: '#e2e8f0',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s'
                    };
                    return /*#__PURE__*/ React.createElement("div", {
                        style: defaultContainerStyle
                    }, /*#__PURE__*/ React.createElement("div", {
                        style: cardStyle
                    }, /*#__PURE__*/ React.createElement("h1", {
                        style: titleStyle
                    }, errorTitle), /*#__PURE__*/ React.createElement("p", {
                        style: messageStyle
                    }, errorMessage), showDetails && this.state.error && /*#__PURE__*/ React.createElement("details", {
                        style: detailsStyle
                    }, /*#__PURE__*/ React.createElement("summary", {
                        style: {
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            marginBottom: '8px',
                            color: '#333'
                        }
                    }, "오류 상세 정보 (개발 모드)"), /*#__PURE__*/ React.createElement("pre", {
                        style: {
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            color: '#e53e3e',
                            marginTop: '8px'
                        }
                    }, this.state.error.toString(), this.state.errorInfo && this.state.errorInfo.componentStack)), /*#__PURE__*/ React.createElement("div", {
                        style: buttonContainerStyle
                    }, /*#__PURE__*/ React.createElement("button", {
                        onClick: this.handleReset,
                        style: primaryButtonStyle,
                        onMouseEnter: function(e) {
                            e.currentTarget.style.backgroundColor = '#2563eb';
                        },
                        onMouseLeave: function(e) {
                            e.currentTarget.style.backgroundColor = '#3182ce';
                        }
                    }, home), /*#__PURE__*/ React.createElement("button", {
                        onClick: this.handleReload,
                        style: secondaryButtonStyle,
                        onMouseEnter: function(e) {
                            e.currentTarget.style.backgroundColor = '#cbd5e0';
                        },
                        onMouseLeave: function(e) {
                            e.currentTarget.style.backgroundColor = '#e2e8f0';
                        }
                    }, reload))));
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    hasError: true,
                    error: error,
                    errorInfo: null
                };
            }
        }
    ]);
    return ErrorBoundary;
}(Component);
export default ErrorBoundary;
